import { H6, Image } from "../../../../AbstractElements";
import { SuccessfullyCompleted } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";

const SuccessfullyFormSubmitted = () => {
  return (
    <div className="form-completed">
      <Image src={dynamicImage("gif/dashboard-8/successful.gif")} alt="successful"/>
      <H6>{SuccessfullyCompleted}</H6>
    </div>
  );
};

export default SuccessfullyFormSubmitted;
